export default {
  accountChangeAplly: "Apply For Change of Information",
  accouuntAppliedBankList: "List of Registered Accounts",
  accountBankType: "Bank Account Type",
  accountTradePaymentBankInfo: "Settlement Fee Transfer Bank Account Information"
};
